const accordionItemTokens = ({
  borders,
  colors,
  space,
  fontSizeBody,
  fontSizeHeading,
  fontWeights,
  iconSizes,
}) => ({
  borders: {
    borderBottomWidth: borders[3],
  },
  colors: {
    borderColorSmall: colors.neutrals[7],
    borderColorBig: colors.neutrals[7],
    headerColor: colors.neutrals[1],
    headerHoverColor: colors.primary['20'],
    arrowColorClosedMd: colors.brandPrimary[1],
    arrowColorOpendMd: colors.brandPrimary[1],
    titleColor: colors.brandPrimary[1],
  },
  space: {
    pxAccordion: space[4],
    pxAccordionPromotional: space[4],
    ptBoxContainer: space[2],
    pyHeaderPositive: space[3],
    pxHeaderPositive: space[2],
    pxHeaderPromotional: space[4],
  },
  fontSizes: {
    fontSizeHeaderPositive: fontSizeBody[1],
    fontSizeHeaderDefault: fontSizeHeading[0],
    fontSizeMdHeaderDefault: fontSizeHeading[0],
  },
  fontWeights: {
    fontWeightHeader: fontWeights.medium,
    fontWeightHeaderOpened: fontWeights.medium,
  },
  iconSizes: {
    arrowIconSize: iconSizes.small,
  },
});

export default accordionItemTokens;
